import axios from 'axios';
import {
  IFRAME_TARGET_URL_LOCAL_STORAGE_KEY,
  TARGET_URL_LOCAL_STORAGE_KEY,
} from './interfaces/constants';
import { bootstrapApp } from './vue';

const nestScriptURL = document.createElement('a');
let fallbackOrigin;
try {
  /* eslint-disable @typescript-eslint/no-unused-expressions */
  (nestScriptURL.href = document.querySelector('script[data-nvbase]') as any)
    ?.src;
  [fallbackOrigin] = nestScriptURL.href.match(/http[s]?:\/\/.[^/]*\//i) as any;
} catch (e) {
  // hm k
}
const baseURL =
  nestScriptURL.origin || fallbackOrigin || document.location.origin;

axios.defaults.baseURL = `${baseURL}/api/`;

axios.interceptors.response.use(null, (error) => {
  if (error.response?.status === 401) {
    const currentUrl = window.location.href;
    const iframeLoginUrl = `${baseURL}/#/iframe-login`;
    if (window.location.href === iframeLoginUrl) {
      throw error;
    } else if (window.self !== window.top) {
      localStorage.setItem(IFRAME_TARGET_URL_LOCAL_STORAGE_KEY, currentUrl);
      window.location.href = iframeLoginUrl;
    } else {
      localStorage.setItem(TARGET_URL_LOCAL_STORAGE_KEY, currentUrl);
      window.location.href = `${baseURL}/api/oauth/login`;
    }
  }

  throw error;
});
bootstrapApp();
